import React from 'react';
import TourDatePicker from 'pages/showing/components/tour-date-picker';
import Section from './section';
import { useAPIData } from 'dal/useAPIData';
import { AUDIENCES } from 'helpers/enums';
import { getToursSettingsInfo } from 'pages/showing/components/tour-date-picker';

const AvailableDates = ({ location, floorplan }) => {
  const representativeItem = floorplan || location;
  const showingEnabled = !!representativeItem?.aptlyShowings?.active;
  const contextId = representativeItem?._id;

  const [data] = useAPIData(
    'context.LOAD_CONTEXT',
    !contextId ? undefined : { contextId, audience: AUDIENCES.showing.uuid },
    { reFetchWhen: [contextId], disableEmptyArgs: true }
  );

  if (!representativeItem || !showingEnabled || !data) return null;
  const { isTimePickerVisible } = getToursSettingsInfo(data);
  if (!isTimePickerVisible) return null;

  const handleDateChange = (date) => {
    if (['custom', 'rently', 'showmojo'].includes(representativeItem.aptlyShowings?.type)) {
      window.open(representativeItem.aptlyShowings.link, '_blank');
    } else {
      if (!date) return;
      const encodedDate = encodeURIComponent(date.toISOString());
      window.open(
        `/${location.companyInfo.id}/showing/app/showing/create/?cId=${representativeItem._id}&tourDate=${encodedDate}`,
        '_blank'
      );
    }
  };

  return (
    <Section label="AVAILABLE TOUR DATES">
      <TourDatePicker location={data} onChange={handleDateChange} />
    </Section>
  );
};

export default AvailableDates;
